import { BASE_URL, VENDOR } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IVendor } from "models/vendor";
import { ICompany } from "models/company";

export async function getVendors(params: string = ""): Promise<IVendor[]> {
  const response = await axios.get(BASE_URL + VENDOR + params);
  return response.data;
}

export async function getCompaniesByVendor(params: string = ""): Promise<ICompany[]> {
  const response = await axios.get(BASE_URL + VENDOR + params);
  return response.data;
}

export async function addVendor(data: FormData, endPoint: string = "") {
  const response = await axios.post(BASE_URL + VENDOR + "/" + endPoint, data);
  return response.data;
}
export async function editVendor(data: FormData, id: string) {
  const response = await axios.patch(BASE_URL + VENDOR + "/" + id, data);
  return response.data;
}

export async function deleteVendor(code: string) {
  const response = await axios.delete(BASE_URL + VENDOR + "/" + code);
  return response.data;
}

export const VendorCells: HeadCell[] = [
  {
    id: "logo",
    numeric: false,
    disablePadding: false,
    label: "T_Logo",
  },
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "nameAr",
    numeric: false,
    disablePadding: false,
    label: "T_name_Ar",
  },
  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "T_email",
  },
  {
    id: "username",
    numeric: false,
    disablePadding: false,
    label: "T_username",
  },
  {
    id: "countryName",
    numeric: false,
    disablePadding: false,
    label: "T_country_name",
  },
   {
    id: "registrationNumber",
    numeric: false,
    disablePadding: false,
    label: "T_registration_number",
  },
  {
    id: "phoneNumber",
    numeric: false,
    disablePadding: false,
    label: "T_phone_number",
  },
  {
    id: "approved",
    numeric: false,
    disablePadding: false,
    label: "T_status",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
